// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_0iK","cls2":"CiterightPreprintReport-cls2_M59 CiterightPreprintReport-cls1_0iK"};